import { axios } from "utils";

import { ADMIN_PARTNERS_URL as endpoint } from "consts";

// admin

export const attachFarm = async (data) => axios.post(`${endpoint}/farmers/attach`, { data });

export const detachFarm = async (data) => axios.post(`${endpoint}/farmers/detach`, { data });

export const addPartner = async (data) => axios.post(`${endpoint}`, { data });

export const getAllPartners = async (data) => axios.get(`${endpoint}`, { data });

export const getPartner = async (data) => axios.get(`${endpoint}/${data.id}`, { data });

export const updatePartner = async (data) => axios.put(`${endpoint}/${data.id}`, { data });

export const addCreditPurchase = async (data) => axios.post(`${endpoint}/${data.partnerId}/credit-purchases`, { data });

export const getCreditPurchase = async (data) => axios.get(`${endpoint}/credit-purchases/${data.id}`, { data });

export const updateCreditPurchase = async (data) => axios.put(`${endpoint}/credit-purchases/${data.id}`, { data });

export const getPartnerFarmers = async (data) => axios.get(`${endpoint}/${data.partnerId}/farmers/`, { data });

export const getPartnerCreditAssignments = async (data) => axios.get(`${endpoint}/${data.id}/credit-assignments`, { data });

export const getPartnerCreditPurchases = async (data) => axios.get(`${endpoint}/${data.id}/credit-purchases`, { data });

export const assignCreditsToPartner = async (data) => axios.post(`${endpoint}/${data.partnerId}/credit-assignments`, { data });

export const unassignCredit = async (data) =>
  axios.delete(`${endpoint}/credit-assignments/${data.assignmentId}`, {
    data,
  });

export const updateAssignedCredit = async (data) =>
  axios.put(`${endpoint}/credit-assignments/${data.assignmentId}`, {
    data,
  });

export const deleteCreditPurchase = async (data) =>
  axios.delete(`${endpoint}/credit-purchases/${data.purchaseId}`, {
    data,
  });

export const getAssignableFarmFieldMethods = async (data) => axios.get(`${endpoint}/assignable-field-methods`, { data });

export const getAssignableFarmFieldModules = async (data) => axios.get(`${endpoint}/assignable-field-modules`, { data });
